import RemitAddressInfoContainer from "./RemitAddressInfoContainer";
export default RemitAddressInfoContainer;
